import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FactSection } from './FactSection';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const f = (fact)=>fact;
export function PeopleView({ pipeline, projectId }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-5",
        children: [
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Key Personnel",
                facts: pipeline.keyPersonnel ?? [],
                accent: "purple",
                projectId: projectId,
                titleFn: (v)=>f(v).role || 'Role',
                metaFn: (v)=>f(v).yearsExperience > 0 ? `${f(v).yearsExperience}+ years` : undefined
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Resume Requirements",
                facts: pipeline.resumeRequirements ?? [],
                accent: "purple",
                projectId: projectId,
                titleFn: (v)=>f(v).pageLimit ? `${f(v).pageLimit}-page resume` : 'Resume requirement',
                metaFn: (v)=>f(v).scope?.replace(/_/g, ' ')
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Past Performance",
                facts: pipeline.pastPerformance ?? [],
                accent: "purple",
                projectId: projectId,
                titleFn: (v)=>{
                    if (f(v).countRequired > 0) return `${f(v).countRequired} reference(s) required`;
                    return 'Past performance';
                },
                metaFn: (v)=>f(v).recencyYears > 0 ? `Within ${f(v).recencyYears} years` : undefined
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "CPARS",
                facts: pipeline.cpars ?? [],
                accent: "purple",
                projectId: projectId,
                titleFn: ()=>'CPARS rating requirement'
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Subcontracting",
                facts: pipeline.subcontracting ?? [],
                accent: "purple",
                projectId: projectId,
                titleFn: (v)=>{
                    const pct = f(v).percentage > 0 ? ` ${f(v).percentage}%` : '';
                    return `${f(v).category || 'Subcontracting'}${pct}`;
                },
                metaFn: (v)=>f(v).details || f(v).participationType?.replace(/_/g, ' ')
            })
        ]
    });
}
